import React from 'react';
import PropTypes from 'prop-types';
import Footer from './ui/Footer';

/**
 * SimpleLayout - A reusable layout for login and participant pages
 * Includes a simplified header with just logo and app name, and the standard footer
 */
const SimpleLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Fixed Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-primary text-white">
        <div className="container mx-auto flex justify-center md:justify-start items-center h-16 px-4">
          {/* Logo and App name - centered on mobile, left-aligned on desktop */}
          <div className="flex items-center space-x-4">
            {/* Logo without link */}
            <div className="shrink-0">
              <img
                src="/assets/prosci-portal-logo.svg"
                alt="Prosci"
                className="h-8 w-auto"
              />
            </div>
            <div className="text-xl font-thin">
              Change Success Assessment
            </div>
          </div>
        </div>
      </header>

      {/* Main content - add padding-top to account for fixed header */}
      <main className="flex-grow bg-muted pt-16 min-h-[calc(100vh-8rem)]">
        {children}
      </main>

      <Footer />
    </div>
  );
};

SimpleLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SimpleLayout; 